export enum CustomerRoles {
  renter = 'renter',
  owner = 'owner',
  admin = 'admin',
}
